import moment from 'moment';

import { ServiceAvailableDate, Interval } from '@packlink/packlink-sdk';

import { COLLECTION_DATE_FORMAT, ICollectionDateForm, IServiceState } from '@types';

export const mapAvailableCollectionDate = (availableDate: ServiceAvailableDate): ICollectionDateForm | null => {
    const date = availableDate.date;
    const tomorrow = moment().add(1, 'days').startOf('day');
    const availableDateIntervals = availableDate.intervals?.map(
        (interval) => new Interval(interval.start, interval.end),
    );

    if (!date || !date?.format) {
        return null;
    }

    let label = date.format(COLLECTION_DATE_FORMAT);

    if (tomorrow.isSame(date)) {
        label += ' (tomorrow)';
    }
    return {
        selectOption: {
            label,
            value: date.toISOString(),
        },
        intervals: availableDateIntervals,
    };
};

export const isPickupValid = (service: IServiceState | null, dropoffPointId: string | null): boolean =>
    !(service?.pickup && !dropoffPointId);
